import React from 'react';
import styled from 'styled-components/macro';

import { size } from '@mirinae/react-ui';

const Layout = styled.div`
    min-width: 280px;
    min-height: calc(100vh - ${size.header});
`;

const ContentsLayout = (props) => {

    return (
        <Layout>
            {props.children}
        </Layout>
    );
};

export default ContentsLayout;